import {Text} from '@/components/ui/text/Text'
import {StyledBudgetAccessRates, StyledBudgetAccessRatesContent} from './style'
import {useTranslation} from '@/translations/i18n'
import {AccessRateCard} from '@/features/budget/components/access-rate-card/AccessRateCard'
import {ExternalCostCode} from '@/features/budget/types'
import {ObjectKeys} from '@/utilities/helpers'

export const BudgetAccessRates = () => {
    const {t} = useTranslation()
    return (
        <StyledBudgetAccessRates>
            <Text size="textXl" weight="500">
                {t('budget:access_rates_title')}
            </Text>
            <StyledBudgetAccessRatesContent>
                {ObjectKeys(ExternalCostCode.enum).map(code => (
                    <AccessRateCard key={code} code={code} />
                ))}
            </StyledBudgetAccessRatesContent>
        </StyledBudgetAccessRates>
    )
}
